module.exports = __webpack_public_path__ + "img/logo_5.eea065c4.jpg";